import ca from 'date-fns/esm/locale/ca';
import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from 'react-router-redux';
import { connect } from "react-redux";
import { actions } from "./redux";
import { Close, DateRange } from "@material-ui/icons";
import { Button, Card, CardContent, Grid, Select, MenuItem, CardHeader, CircularProgress, Modal, TextField } from "@material-ui/core";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import CSSModules from "react-css-modules";
import SearchBar from "../../components/SearchBar/SearchBar";
import { DateTime } from "../../utils";
import Graph from "../../components/OutcomeGraph/OutcomeGraph";
import moment from "moment-timezone";
import { DateRangePicker, Calendar } from "../../libs/react-date-range";
import EvidenceChart from "../../components/EvidenceComponents/Chart/EvidenceChart";
import EvidenceList from "../../components/EvidenceComponents/List/EvidenceList";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";

import ziggy_s from "../../assets/Icons/ziggy_selected.png";
import list_s from "../../assets/Icons/list_view_selected-01.png";
import ziggy_us from "../../assets/Icons/ziggy_unselected.png";
import list_us from "../../assets/Icons/list_view_unselected-01.png";

import aa_shape from "../../assets/Svgs/aa-shape.svg";
import dr_shape from "../../assets/Svgs/dr-shape.svg";
import ic_shape from "../../assets/Svgs/ic-shape.svg";
import pst_square from "../../assets/Svgs/pst-square.svg";
import vrf_line from "../../assets/Svgs/vrf-line.svg";
import co_shape from "../../assets/Svgs/co-shape.svg";

import { actions as evidenceServiceActions } from "../../services/Evidence/redux";
import TimeOutsideRangeChart from '../../components/ReportComponents/Charts/TimeOutsideRangeChart/TimeOutsideRangeChart';

@CSSModules(styles, { allowMultiple: true })
class Chart extends Component {
	constructor(props) {
		super(props);

		this.state = {
			implementedChangesModalOpen: false, 
			preSetTestsModalOpen: false,
			commentModalOpen: false,
			deleteConfirmModalOpen: false,
			modalCalendarOpen: false,
			errors: [],
			ic_desc: "",
			ic_length: "",
			ic_time: "00:00",
			co_time: "00:00",
			co_desc: "",
			pst_desc: "",
			pst_length: "1",
			pst_occurs: "",
			editDto: null,
			searchSelectOpen: false,
		};

		this.handleICSelect = this.handleICSelect.bind(this);
		this.handlePSTSelect = this.handlePSTSelect.bind(this);
		this.handleCOSelect = this.handleCOSelect.bind(this);
		this.isIcErrors = this.isIcErrors.bind(this);
		this.isPstErrors = this.isPstErrors.bind(this);
		this.editModalCall = this.editModalCall.bind(this);
		this.deleteCall = this.deleteCall.bind(this);

		this.handleSearchSelectChange = this.handleSearchSelectChange.bind(this);
		this.handleSearchSelectClose = this.handleSearchSelectClose.bind(this);
		this.handleSearchSelectOpen = this.handleSearchSelectOpen.bind(this);
	}

   	componentWillMount() {
		
	}

	convertToMins(time) {
		return moment.duration(moment(time.endDate).diff(time.startDate)).asMinutes();
	}

	changeTime(result) {
		result.selection.endDate = DateTime.endOf("day", result.selection.endDate);
		this.props.changeTime(result);
	}

	resetImplementedChangesModal() {
		this.props.resetImplementedChanges();
		this.setState({implementedChangesModalOpen: true, errors: [], ic_desc: "", ic_time: "00:00", ic_length: "", editDto: null});
	}

	resetPreSetTestsModal() {
		this.props.resetPreSetTests();
		this.setState({preSetTestsModalOpen: true, errors: [], pst_length: "1", pst_desc: "", editDto: null});
	}

	resetCommentModal() {
		this.props.resetComment();
		this.setState({commentModalOpen: true, errors: [], co_time: "00:00", co_desc: "", editDto: null});
	}

	handleICSelect(date) {
		this.props.setImplementedChangeDate(date);
	}

	handlePSTSelect(date) {
		this.props.setPreSetTestDate(date);
	}

	handleCOSelect(date) {
		this.props.setCommentDate(date);
	}

	handleSearchSelectChange(event) {
		this.props.setSearchValue(event.target.value);
	}

	handleSearchSelectOpen() {
		this.setState({searchSelectOpen: true});
	}

	handleSearchSelectClose() {
		this.setState({searchSelectOpen: false});
	}

	saveImplementedChange() {
		if(this.isIcErrors()) {
			return;
		}
		this.props.saveImplementedChange(this.state.editDto);
		this.setState({implementedChangesModalOpen: false, modalCalendarOpen: false});
	}

	savePreSetTests() {
		if(this.isPstErrors()) {
			return;
		}
		this.props.savePreSetTests(this.state.editDto);
		this.setState({preSetTestsModalOpen: false, modalCalendarOpen: false});
	}

	saveComment() {
		if(this.isCoErrors()) {
			return;
		}
		this.props.saveComment(this.state.editDto);
		this.setState({commentModalOpen: false, modalCalendarOpen: false});
	}

	closeCalendar() {
		this.props.toggleCalendar();
	}
	
	clearModalData() {
		var view = document.getElementById("viewValue");
		var compare = document.getElementById("comparisonValue");
		var type = document.getElementById("compareTypeValue");
		if(view) {
			view.value = "-1";
		}
		if(compare) {
			compare.value = "-1";
		}
		if(type) {
			type.value = "-1";
		}
		this.props.clearModalData();
	}

	isIcErrors() {
		let errors = [];
		if(!this.props.ic_description || this.props.ic_description === "") {
			errors.push("Description missing.")
		}
		if(!this.props.viewId) {
			errors.push("Missing view.");
		}
		if(this.props.viewId && !this.props.ic_comparisonId) {
			errors.push("Missing comparison point.");
		}
		if(this.props.viewId && !this.props.ic_compareType) {
			errors.push("Missing comparison method.");
		}
		if(errors.length > 0) {
			this.setState({errors: errors});
			return true;
		} else {
			return false;
		}
	}

	isPstErrors() {
		let errors = [];
		if(!this.props.pst_length || this.props.pst_length <= 0) { errors.push("Length must be greater than zero.")}
		if(!this.props.pst_occurs || this.props.pst_occurs <= 0) { errors.push("Occurs must be greater than zero")}
		if(!this.props.pst_description || this.props.pst_description === "") { errors.push("Description missing.")}
		this.props.pst_descriptions.forEach((x, i) => {
			if(!x || x === "") { errors.push("Description #" + (i + 1) + " missing.")}

			let y = this.checkDescriptionsErrors(this.props.pst_descriptions, i, this.props.pst_length, this.props.pst_isDays);
			if(y) {
				errors.push("Description #" + (i + 1) + ": " + y + ".");
			}
		});
		if(!this.props.viewId) {
			errors.push("Missing view.");
		}

		this.setState({errors: errors});
		if(errors.length > 0) {
			return true;
		} else {
			return false;
		}
	}

	isCoErrors() {
		let errors = [];
		if(!this.props.co_description || this.props.co_description === "") {
			errors.push("Description missing.")
		}
		if(errors.length > 0) {
			this.setState({errors: errors});
			return true;
		} else {
			return false;
		}
	}

   sameDay(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
	}
	
	getView(flattenedSiteTree, rootView, paths){
		let result = null;
	
		let wkView = rootView;
		if(flattenedSiteTree && rootView && paths && paths.length && flattenedSiteTree.Roots.length){
			for(var ii = 0; ii < paths.length; ii++){
				let wkPath = paths[ii];
				let nextView = null;
				
				const childs = flattenedSiteTree.GetChildrenFor(wkView);
	
				for (let index = 0; index < childs.length; index++) {
					const childView = childs[index];
					if(childView.name === wkPath){
						nextView = childView;
						break;
					}
				}
	
				if(!nextView){
					break;
				}else{
					wkView = nextView;
				}
				if(ii === paths.length - 1){
					result = wkView;
				}
			}
		}
	
		return result;
	}

	getViewDropdown(flattenedSiteTree, currentSite, isPreSetTest) {
		let viewView = this.getView(flattenedSiteTree, currentSite, ["Evidence"]);
		if(!viewView) {
			return <div />
		}
		let evidenceViews = [];

		for(var view in viewView._tree.children) {
			if(viewView._tree.children.hasOwnProperty(view)) { // Evidence/SET
				evidenceViews.push(flattenedSiteTree[viewView._tree.children[view]]);
			}
		}

		return (
			<select styleName={isPreSetTest ? "viewSelectPst" : "viewSelectIc"} id="viewValue" onChange={() => {isPreSetTest ? this.props.setPreSetTestViewId("viewValue", "-1") : this.props.setImplementedChangeViewId("viewValue", "-1")}}>
				{
					this.props.viewId === null &&
					evidenceViews.length > 0 &&
					<option value="-1">Views*</option>
				}
				{
					evidenceViews.length === 0 &&
					<option value="-1">No views available</option>
				}
				{
					evidenceViews.map((view, index) => {
						return (
							<option key={index} value={view.objectID}>{view.name}</option>
						)
					})
				}
			</select>
		);
	}

	getComparisonDropdown(flattenedSiteTree, currentSite, viewId) {
		let viewView = this.getView(flattenedSiteTree, currentSite, ["Evidence"]);
		if(!viewView) {
			return <div />
		}
		let evidenceViews = [];

		if(viewId) {
			for(var view in viewView._tree.children) {
				if(viewView._tree.children.hasOwnProperty(view)) { // Evidence/SET
					let parent = flattenedSiteTree[viewView._tree.children[view]];
					if(parent && parent.objectID === viewId.toString()) {
						for(var pview in parent._tree.children) {
							if(parent._tree.children.hasOwnProperty(pview)) { // Evidence/Set/CHART
								let child = flattenedSiteTree[parent._tree.children[pview]];
								for(var cview in child._tree.children) {
									if(child._tree.children.hasOwnProperty(cview)) { // Evidence/Set/Chart/POINT
										evidenceViews.push(flattenedSiteTree[child._tree.children[cview]]);
									}
								}
							}
						}
					}
				}
			}
		}

		return (
			<select styleName="viewSelectIc" id="comparisonValue" onChange={() => this.props.setImplementedChangeComparisonId("comparisonValue", "-1")}>
				{
					this.props.ic_comparisonId === null &&
					evidenceViews.length > 0 &&
					<option value="-1">Comparison Points*</option>
				}
				{
					evidenceViews.length === 0 &&
					this.props.viewId !== null &&
					<option value="-1">No points for comparison</option>
				}
				{
					evidenceViews.length === 0 &&
					this.props.viewId === null &&
					<option value="-1">Select a view above</option>
				}
				{
					evidenceViews.map((view, index) => {
						return (
							<option key={index} value={view.databaseID}>{view.name}</option>
						)
					})
				}
			</select>
		);
	}

	getImplementedChangeModal() {
		return (
			<Modal open={this.state.implementedChangesModalOpen}
				styleName="chart-modal-container"
				onClose={() => {
					this.setState({ implementedChangesModalOpen: false });
					this.clearModalData();
				}}>
				<div className="modal-wrap">
					<div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
						<div style={{flex: 1}} />
						<CloseIcon onClick={() => {this.setState({ implementedChangesModalOpen: false }); this.clearModalData(); }}/>
					</div>
					<div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
						<div>
							<div styleName="modal-title">{this.state.editDto ? "Edit " : "New "}Implemented Change</div>
						</div>
						<div styleName="chart-modal-inner-content">
							<div styleName="chart-date-container">
								<div styleName="chart-title">Select Time & Date</div>
								<TextField styleName="ic-time" id="ic_time" value={this.state.ic_time} type="time" defaultValue="00:00" inputProps= {{step: 300}} onChange={(evt) => {this.setState({ic_time: evt.target.value}); this.props.setImplementedChangeTime(evt.target.value)}} />
								<div styleName="ic-chart-date-actual-container" className="ic-chart-date-actual-container-class">
									<Calendar date={this.props.ic_date} onChange={this.handleICSelect} color="#FCB828"/>
								</div>
								<div style={{display: "flex", flexDirection: "column", alignItems: "center", minHeight: "60px", paddingBottom: "20px", paddingTop: "30px"}}>
									<div styleName="chart-title">Select Length</div>
									<div style={{flex: 1, display: "flex", flexDirection: "row", alignItems: "flex-end"}}>
										<TextField id="ic_length" value={this.state.ic_length} type="number" onChange={(evt) => {this.setState({ic_length: evt.target.value}); this.props.setImplementedChangeLength(evt.target.value)}} styleName="pst-f1 ic-length" />
										<Button onClick={() => this.props.setImplementedChangeIsDays(true)} styleName={this.props.ic_isDays ? "ic-button ic-button-active" : "ic-button ic-button-inactive"}>Days</Button>
										<Button onClick={() => this.props.setImplementedChangeIsDays(false)} styleName={this.props.ic_isDays ? "ic-button ic-button-inactive" : "ic-button ic-button-active"}>Weeks</Button>
									</div>
								</div>
							</div>
							<div styleName="chart-description-container">
								<img src={ic_shape} styleName="chart-description-image" alt="" />
								<TextField id="ic_desc" type="text" value={this.state.ic_desc} onChange={(evt) => {this.setState({ic_desc: evt.target.value}); this.props.setImplementedChangeDescription(evt.target.value)}} label="Description" multiline={true} styleName="ic-description" />
								
								<div styleName="pst-f1" />
								
								<div styleName="viewContainer">
									{
										this.props.flattenedSiteTree && this.props.currentSite &&
										this.getViewDropdown(this.props.flattenedSiteTree, this.props.currentSite, false)
									}
								</div>
								<div styleName="viewContainer">
									{
										this.getComparisonDropdown(this.props.flattenedSiteTree, this.props.currentSite, this.props.viewId)
									}
								</div>
								<div styleName="viewContainer">
									<select styleName="viewSelectIc" id="compareTypeValue" onChange={() => this.props.setImplementedChangeCompareType("compareTypeValue", "-1")}>
										{
											this.props.ic_compareType === null &&
											<option value="-1">Comparison Method*</option>
										}
										<option value="Avg">Average</option>	
										<option value="Min">Min</option>
										<option value="Max">Max</option>
										<option value="Count">Count</option>
									</select>
								</div>

								<div styleName="viewContainer">
									<Button onClick={() => this.saveImplementedChange()} styleName="ic-save-button">
										Save
									</Button>
								</div>
								<div styleName="viewContainer">
									{
										this.state.errors.map((error, index) => {
											return (<div styleName="pst-error" key={index}>{error}</div>)
										})
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	getCommentModal() {
		return (
			<Modal open={this.state.commentModalOpen}
				styleName="chart-modal-container"
				onClose={() => {
					this.setState({ commentModalOpen: false });
					this.clearModalData();
				}}>
				<div className="modal-wrap">
					<div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
						<div style={{flex: 1}} />
						<CloseIcon onClick={() => {this.setState({ commentModalOpen: false }); this.clearModalData(); }}/>
					</div>
					<div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
						<div>
							<div styleName="modal-title">{this.state.editDto ? "Edit " : "New "}Comment</div>
						</div>
						<div styleName="chart-modal-inner-content">
							<div styleName="chart-date-container">
								<div styleName="chart-title">Select Time & Date</div>
								<TextField styleName="co-time" id="co_time" value={this.state.co_time} type="time" defaultValue="00:00" inputProps= {{step: 300}} onChange={(evt) => {this.setState({co_time: evt.target.value}); this.props.setCommentTime(evt.target.value)}} />
								<div styleName="co-chart-date-actual-container" className="co-chart-date-actual-container-class">
									<Calendar date={this.props.co_date} onChange={this.handleCOSelect} color="#7B52A6"/>
								</div>
							</div>
							<div styleName="chart-description-container">
								<img src={co_shape} alt="" styleName="chart-description-image"/>
								<div styleName="co-description-container">
									<TextField id="co_desc" value={this.state.co_desc} type="text" onChange={(evt) => {this.setState({co_desc: evt.target.value}); this.props.setCommentDescription(evt.target.value)}} label="Description" multiline={true} styleName="co-description" />
								</div>
								<div style={{flex: 1}} />
								<div styleName="co-save-container">
									<Button onClick={() => this.saveComment()} styleName="co-save-button">
										Save
									</Button>
								</div>
								<div styleName="pst-error-container">
									{
										this.state.errors.map((error, index) => {
											return (<div styleName="pst-error" key={index}>{error}</div>)
										})
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	checkDescriptionsErrors(descriptions, index, length, isDays) {
		let check = null;
		if(descriptions[index]) {
			check = descriptions[index];
		}
		if(!check || !check.startDate) {
			return "No date selected for test.";
		}

		let before = null;
		let after = null;

		if(index === 0) {
			return;
		}

		if(descriptions[index - 1]) {
			before = descriptions[index - 1];
		}
		if(descriptions[index + 1]) {
			after = descriptions[index + 1];
		}

		if(before && before.startDate) {
			let beforeEnd = moment(before.startDate).add(isDays ? (length - 1) : ((length * 7) - 1), "days").endOf("day").toDate();
			if(beforeEnd >= check.startDate) {
				return "Date too close to previous test.";
			} 
		}

		if(after && after.startDate) {
			let checkEnd = moment(check.startDate).add(isDays ? (length - 1) : ((length * 7) - 1), "days").endOf("day").toDate();
			if(checkEnd >= after.startDate) {
				return "Date too close to next test.";
			}
		}
		
	}

	clickPreSetTestOccurs(num) {
		var id = "pst-b-" + num;
		this.props.setPreSetTestOccurs(num);

		var elem = document.getElementById(id);
		if(elem) {
			setTimeout(elem.blur(), 100);
		}
	}

	getPreSetTestModal() {
		return (
			<Modal open={this.state.preSetTestsModalOpen}
				styleName="chart-modal-container"
				onClose={() => {
					this.setState({ preSetTestsModalOpen: false });
					this.clearModalData();
				}}>
				<div className="modal-wrap">
					<div style={{marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
						<div style={{flex: 1}} />
						<CloseIcon onClick={() => {this.setState({ preSetTestsModalOpen: false }); this.clearModalData(); }}/>
					</div>
					<div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column", minHeight: "500px"}}>
						<div styleName="modal-title">{this.state.editDto ? "Edit " : "New "} Pre-Set Test</div>
						<div styleName="chart-modal-inner-content">
							<div style={{display: "flex", flexDirection: "column", alignItems: "center", minHeight: "73px"}}>
								<div styleName="chart-title">Occurs</div>
								<div styleName="pst-f">
									<div id="pst-b-1" onClick={() => this.clickPreSetTestOccurs(1)} styleName={this.props.pst_occurs === 1 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>1</div>
									<div id="pst-b-2" onClick={() => this.clickPreSetTestOccurs(2)} styleName={this.props.pst_occurs === 2 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>2</div>
									<div id="pst-b-3" onClick={() => this.clickPreSetTestOccurs(3)} styleName={this.props.pst_occurs === 3 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>3</div>
									<div id="pst-b-4" onClick={() => this.clickPreSetTestOccurs(4)} styleName={this.props.pst_occurs === 4 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>4</div>
									<div id="pst-b-5" onClick={() => this.clickPreSetTestOccurs(5)} styleName={this.props.pst_occurs === 5 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>5</div>
									<div id="pst-b-6" onClick={() => this.clickPreSetTestOccurs(6)} styleName={this.props.pst_occurs === 6 ? "pst-occur-circle pst-occur-circle-active" : "pst-occur-circle pst-occur-circle-inactive"}>6</div>
								</div>
							</div>
							<div style={{display: "flex", flexDirection: "column", alignItems: "center", minHeight: "73px"}}>
								<div styleName="chart-title">Length</div>
								<div style={{flex: 1, display: "flex", flexDirection: "row", alignItems: "flex-end", marginLeft: "20px"}}>
									<TextField id="pst_length" value={this.state.pst_length} defaultValue="1" type="number" onChange={(evt) => {this.setState({pst_length: evt.target.value}); this.props.setPreSetTestLength(evt.target.value)}} styleName="pst-f1 pst-length" />
									<Button onClick={() => this.props.setPreSetTestIsDays(true)} styleName={this.props.pst_isDays ? "pst-button pst-button-active" : "pst-button pst-button-inactive"}>Days</Button>
									<Button onClick={() => this.props.setPreSetTestIsDays(false)} styleName={this.props.pst_isDays ? "pst-button pst-button-inactive" : "pst-button pst-button-active"}>Weeks</Button>
								</div>
							</div>
						</div>
						{
							this.props.pst_occurs !== null && 
							this.props.pst_occurs > 0 && 
							this.props.pst_length !== null && 
							this.props.pst_length > 0 && 
							this.props.pst_isDays !== null && 
							<div style={{marginTop: "10px"}}>
								<div style={{paddingTop: "10px", paddingLeft: "10px"}}>
									<TextField id="pst_desc" value={this.state.pst_desc} type="text" onChange={(evt) => {this.setState({pst_desc: evt.target.value}); this.props.setPreSetTestDescription(evt.target.value)}} label="Description" multiline={true} styleName="pst-description" />
								</div>
								{
									this.props.pst_descriptions.map((desc, index) => {
										return (
											<div key={index} styleName="pst-f">
												<div >
													<div styleName="pst-number">{index + 1}</div>
												</div>
												<div style={{paddingTop: "10px", paddingLeft: "10px", display: "flex", flex: 1, flexDirection: "column"}}> 
													<div style={{cursor: (desc.startDate || (index === 0 && !desc.startDate)) ? "pointer" : "unset", alignItems: "flex-end", display: "flex", flexDirection: "row"}}
														onClick={() => (desc.startDate || (index === 0 && !desc.startDate)) ? this.setState({modalCalendarOpen: true, modalCalendarIndex: index}) : {}}
														>
														{(!desc.startDate) && <DateRange size={20} styleName="disabled-date-icon" />}
														{(desc.startDate) && <DateRange size={20} styleName="enabled-date-icon" />}
														{(index === 0 && !desc.startDate) && "Select start date."}
														{(desc.startDate) && moment(desc.startDate).format("dddd, DD MMM")}
														<div style={{color: "#F00", fontSize: "12px", marginLeft: "10px"}}>
														{
															this.checkDescriptionsErrors(this.props.pst_descriptions, index, this.props.pst_length, this.props.pst_isDays)
														}
														</div>
													</div>
													<TextField id={"t" + (index + 1).toString + "Description"} value={desc.description} type="text" onChange={(evt) => this.props.setPreSetTestDescriptions(index, evt.target.value)} label={"Test " + (index + 1) + " Description"} multiline={true} styleName="pst-description" />
												</div>
											</div>
										)
									})
								}
							</div>
						}
						{ 
							this.props.pst_occurs !== null && 
							this.props.pst_occurs > 0 && 
							this.props.pst_length !== null && 
							this.props.pst_length > 0 && 
							this.props.pst_isDays !== null && 
							<div styleName="viewContainer">
								{
									this.props.flattenedSiteTree && this.props.currentSite &&
									this.getViewDropdown(this.props.flattenedSiteTree, this.props.currentSite, true)
								}
							</div>
						}
						{ 
							this.props.pst_occurs !== null && 
							this.props.pst_occurs > 0 && 
							this.props.pst_length !== null && 
							this.props.pst_length > 0 && 
							this.props.pst_isDays !== null && 
							<div styleName="viewContainer">
								<Button styleName="pst-save-button" onClick={() => this.savePreSetTests()}>
									Save
								</Button>
							</div>
						}
						<div styleName="pst-error-container">
							{
								this.state.errors.map((error, index) => {
									return (<div styleName="pst-error" key={index}>{error}</div>)
								})
							}
						</div>
						<div styleName="calendar-wrap-modal" isopen={this.state.modalCalendarOpen.toString()}>
							<div styleName="drpContainer" className="pst-calendar-class">
								<Calendar
									date={new Date()}
									onChange={s => {this.props.setPreSetTestDescriptionsDate(this.state.modalCalendarIndex, s); this.setState({modalCalendarOpen: false})}}
									color="#2E9BB1"
								/>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	} 

	getDeleteConfirmModal() {
		return (
			<Modal open={this.state.deleteConfirmModalOpen}
				styleName="chart-modal-container"
				onClose={() => {
					this.setState({ deleteConfirmModalOpen: false });
				}}>
				<div className="modal-wrap">
					<div style={{marginTop: -10, marginRight: -10, display: "flex", flexDirection: "row", cursor: "pointer"}}>
						<div style={{flex: 1}} />
						<CloseIcon onClick={() => this.setState({ deleteConfirmModalOpen: false })}/>
					</div>
					<div styleName="chart-modal-content" style={{display: "flex", flexDirection: "column"}}>
						<div styleName="modal-title">Delete</div>
						<div styleName="chart-modal-inner-content" style={{marginTop: 10, justifyContent: "space-evenly"}}>
							<Button styleName="confirm-button confirm-button-no" onClick={() => this.setState({deleteConfirmModalOpen: false})}>No</Button>
							<Button styleName="confirm-button" style={{backgroundColor: this.state.deleteType === "ImplementedChange" ? "#fcb828" : this.state.deleteType === "PreSetTest" ? "#2e9bb1" : "#7b52a6" }} onClick={() => {
								this.setState({deleteConfirmModalOpen: false}); 
								switch(this.state.deleteType) {
									case "ImplementedChange":
										this.props.deleteImplementedChange(this.state.deleteId);
										break;
									case "PreSetTest":
										this.props.deletePreSetTest(this.state.deleteId);
										break;
									case "Comment":
										this.props.deleteComment(this.state.deleteId);
										break;
									default:
										break;
								}
							}}>Yes</Button>
						</div>
					</div>
				</div>
			</Modal>
		);
	} 

	editModalCall(type, data) {
		switch(type) {
			case "ImplementedChange":
				this.resetImplementedChangesModal();
				this.setState({editDto: data, ic_desc: data.description, ic_time: moment(data.implementedOn).utc().format("HH:mm"), ic_length: data.lengthDays});
				if(data.iEnergyViewId) {this.props.reverseSetImplementedChangeViewId("viewValue", data.iEnergyViewId);}
				if(data.comparisonId) {this.props.reverseSetImplementedChangeComparisonId("comparisonValue", data.comparisonId);}
				if(data.compareType) {this.props.reverseSetImplementedChangeCompareType("compareTypeValue", data.compareType);}
				this.props.setImplementedChangeDate(moment(data.implementedOn).utc().toDate());
				this.props.setImplementedChangeIsDays(true);
				this.props.setImplementedChangeTime(moment(data.implementedOn).utc().format("HH:mm"));
				this.props.setImplementedChangeDescription(data.description);
				this.props.setImplementedChangeLength(data.lengthDays);
				break;
			case "PreSetTest":
				this.resetPreSetTestsModal();
				this.setState({editDto: data, pst_length: data.daysPerTest, pst_desc: data.description});
				this.props.setPreSetTestDate(moment(data.startDate).utc().toDate());
				this.props.setPreSetTestDescription(data.description);
				this.props.setPreSetTestIsDays(true);
				this.props.setPreSetTestLength(data.daysPerTest);
				this.props.setPreSetTestOccurs(data.preSetTestItems.length);
				if(data.iEnergyViewId) {this.props.reverseSetPreSetTestViewId("viewValue", data.iEnergyViewId);}
				data.preSetTestItems.forEach((pst, index) => {
					this.props.setPreSetTestDescriptions(index, pst.description);
					this.props.setPreSetTestDescriptionsDate(index, moment(pst.fromDate).utc().toDate());
				});
				break;
			case "Comment":
				this.resetCommentModal();
				this.setState({editDto: data, co_desc: data.description, co_time: moment(data.implementedOn).utc().format("HH:mm")})
				this.props.setCommentDate(moment(data.implementedOn).utc().toDate());
				this.props.setCommentDescription(data.description);
				this.props.setCommentTime(moment(data.implementedOn).utc().format("HH:mm"));
				break;
			default:
				break;
		}
	}
	
	deleteCall(type, data) {
		switch(type) {
			case "ImplementedChange":
				this.setState({deleteConfirmModalOpen: true, deleteType: type, deleteId: data.implementedChangeId})
				break;
			case "PreSetTest":
				this.setState({deleteConfirmModalOpen: true, deleteType: type, deleteId: data.preSetTestId})
				break;
			case "Comment":
				this.setState({deleteConfirmModalOpen: true, deleteType: type, deleteId: data.commentId})
				break;
			default:
				break;
		}
	}

	render() {
		return (
			<div styleName="outer">
				{/* click area to close calender */}
				{this.props.calendarOpen && <div onClick={() => this.props.toggleCalendar()} styleName="toggle-area" />}
				<div styleName="header">
					<div styleName="header-spacer">
						<div styleName="btnwrap">
							{
								this.props.showingDataType === "List" &&
								<img src={list_s} styleName="iconbtn" alt="" />
							}
							{
								this.props.showingDataType === "List" &&
								<img src={ziggy_us} styleName="iconbtn" alt="" onClick={() => this.props.changeShowingDataType("Chart")} />
							}
								
							{
								this.props.showingDataType === "Chart" &&
								<img src={list_us} styleName="iconbtn" alt="" onClick={() => this.props.changeShowingDataType("List")} />
							}
							{
								this.props.showingDataType === "Chart" &&
								<img src={ziggy_s} styleName="iconbtn" alt="" />
							}
							{
								this.props.showingDataType === "List" &&
								<div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
									<div style={{position: "relative", minWidth: 200}}>
										<SearchBar
											timeout={500}
											searchBarId={"evidence/List"}
											style={{
												backgroundColor: "transparent",
												height: 60,
												marginLeft: 15,
												marginRight: 15,
												paddingRight: 15,
												borderBottomWidth: 0,
												minWidth: 200,
											}}
											inputStyle={{ borderWidth: 0, marginRight: 40 }}
											iconStyle={{ color: "#FFFFFF" }}
											inputWrapClass="_inputWrap-42"
										/>
										<Select
											open={this.state.searchSelectOpen}
											onClose={this.handleSearchSelectClose}
											onOpen={this.handleSearchSelectOpen}
											value={this.props.searchValue}
											onChange={this.handleSearchSelectChange}
											styleName="searchSelect"
										>
											<MenuItem value="AutomatedActions"><img src={aa_shape} styleName="twentyfive" alt="Automated Actions" />{this.state.searchSelectOpen ? <span styleName="left-5">Automated Actions</span> : ""}</MenuItem>
											<MenuItem value="DiagnosticRules"><img src={dr_shape} styleName="twentyfive" alt="Diagnostic Rules" />{this.state.searchSelectOpen ? <span styleName="left-5">Diagnostic Rules</span> : ""}</MenuItem>
											<MenuItem value="ImplementedChanges"><img src={ic_shape} styleName="twentyfive" alt="Implemented Changes" />{this.state.searchSelectOpen ? <span styleName="left-5">Implemented Changes</span> : ""}</MenuItem>
											<MenuItem value="PreSetTests"><img src={pst_square} styleName="twentyfive" alt="Pre-Set Tests" />{this.state.searchSelectOpen ? <span styleName="left-5">Pre-Set Tests</span> : ""}</MenuItem>
											<MenuItem value="VerificationRuleFailures"><img src={vrf_line} styleName="twentyfive" alt="Verification Rule Failures" />{this.state.searchSelectOpen ? <span styleName="left-5">Verification Rule Failures</span> : ""}</MenuItem>
											<MenuItem value="Comments"><img src={co_shape} styleName="twentyfive" alt="Comments" />{this.state.searchSelectOpen ? <span styleName="left-5">Comments</span> : ""}</MenuItem>
										</Select>
									</div>
									{
										this.props.searchText &&
										this.props.searchText !== "" &&
										<Button onClick={() => this.props.search()}>
											Search
										</Button>
									}
									{
										this.props.hasSearched &&
										<Button onClick={() => this.props.clearSearch()}>
											Clear
										</Button>
									}
									{
										this.props.isSearchBusy &&
										<CircularProgress />
									}
									{
										this.props.hasSearched === true &&
										<div styleName="searchResults">
											{this.props.searchResults} results found.
										</div>
									}
								</div>
							}
						</div>
						{ 
							this.props.showingDataType === "Chart" &&
							<div styleName="time-container-large">
								{this.props.isBusy && <CircularProgress />}
								<Button onClick={() => this.props.toggleCalendar()} styleName="date-btn">
									{
										this.props.time && this.props.time.startDate && this.props.time.endDate &&
										this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
										`${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`
									}
									{
										!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
										`${DateTime.formatToLocaleLongDate(this.props.time.startDate)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`
									}
									{
											this.props.calendarOpen &&
											<ArrowDropUp style={{fill: "rgb(0, 0, 0, 0.54)"}} />
									
									}
									{
											!this.props.calendarOpen &&
											<ArrowDropDown style={{fill: "rgb(0, 0, 0, 0.54)"}} />
									}
								</Button>
								<div styleName="calendar-wrap" isopen={this.props.calendarOpen.toString()}>
									<div styleName="drpContainer">
										<DateRangePicker
											ranges={[this.props.time]}
											dragSelectionEnabled={false}
											showSelectionPreview={false}
											onChange={s => this.changeTime(s)}
										/>
										<div styleName="drpCloseButtonContainer">
											<div style={{flex: 1}} />
											<div styleName="drpCloseButton" onClick={() => this.closeCalendar()}>Close</div>
										</div>
									</div>
								</div>
							</div>
						}
					</div>
					</div>
					{
						(!this.props.currentSite) &&
						<div styleName="spinner">
							<CircularProgress />
						</div>
					}
					{ this.props.currentSite &&
					<div styleName="content">
						<div styleName="smallcardwrp">
							<Card styleName="smallcard mRight" onClick={() => { this.resetImplementedChangesModal(); }}>
								<img src={ic_shape} alt="" styleName="linewrap twentyfive" />Add Implemented Changes
							</Card>
							<Card styleName="smallcard mLeft mRight" onClick={() => { this.resetPreSetTestsModal(); }}>
								<img src={pst_square} alt="" styleName="linewrap twentyfive" />Add Pre-Set Tests
							</Card>
							<Card styleName="smallcard mLeft" onClick={() => { this.resetCommentModal(); }}>
								<img src={co_shape} alt="" styleName="linewrap twentyfive" />Add Comment
							</Card>
						</div>
						<div styleName="time-container-small">
							{this.props.isBusy && <CircularProgress />}
							<div>
								<Button onClick={() => this.props.toggleCalendar()} styleName="date-btn">
								{
									this.props.time && this.props.time.startDate && this.props.time.endDate &&
									this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
									`${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`
								}
								{
									!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
									`${DateTime.formatToLocaleLongDate(this.props.time.startDate)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`
								}
								</Button>
							</div>
						</div>
						<Card styleName="maincard">
							<CardContent styleName="cardcontent">
								<Grid container styleName="table">
									<Grid item container>
										<Grid item xs={12}>
											{
												this.props.showingDataType === "Chart" &&
												<EvidenceChart time={this.props.time} site={this.props.currentSite} rerender={this.props.rerender} />
											}
											{
												this.props.showingDataType === "List" &&
												<EvidenceList time={this.props.time} site={this.props.currentSite} rerender={this.props.rerender} editcall={this.editModalCall} deletecall={this.deleteCall} />
											}
										</Grid>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</div>
					}

					{this.getImplementedChangeModal()}
					{this.getPreSetTestModal()}
					{this.getCommentModal()}
					{this.getDeleteConfirmModal()}
				</div>
		);
	}
}

const bindAction = dispatch => {
   	return {
			toggleCalendar: () => dispatch(actions.toggleCalendar()),

			changeShowingDataType: (type) => dispatch(actions.changeShowingDataType(type)),

			changeTime: (time) => dispatch(evidenceServiceActions.changeTime(time)),

			saveImplementedChange: (editDto) => dispatch(actions.saveImplementedChange(editDto)),
			resetImplementedChanges: () => dispatch(actions.resetImplementedChanges()),
			saveComment: (editDto) => dispatch(actions.saveComment(editDto)),
			resetComment: () => dispatch(actions.resetComment()),
			savePreSetTests: (editDto) => dispatch(actions.savePreSetTests(editDto)),
			resetPreSetTests: () => dispatch(actions.resetPreSetTests()),

			setImplementedChangeTime: (time) => dispatch(actions.setImplementedChangeTime(time)),
			setImplementedChangeDate: (date) => dispatch(actions.setImplementedChangeDate(date)),
			setImplementedChangeDescription: (desc) => dispatch(actions.setImplementedChangeDescription(desc)),
			setImplementedChangeLength: (length) => dispatch(actions.setImplementedChangeLength(length)),
			setImplementedChangeIsDays: (isDays) => dispatch(actions.setImplementedChangeIsDays(isDays)),
			setImplementedChangeViewId: (htmlId, defaultValue) => dispatch(actions.setImplementedChangeViewId(htmlId, defaultValue)),
			setImplementedChangeComparisonId: (htmlId, defaultValue) => dispatch(actions.setImplementedChangeComparisonId(htmlId, defaultValue)),
			setImplementedChangeCompareType: (htmlId, defaultValue) => dispatch(actions.setImplementedChangeCompareType(htmlId, defaultValue)),

			// These will take a value and force it into the UI
			reverseSetImplementedChangeViewId: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeViewId(htmlId, value)),
			reverseSetImplementedChangeComparisonId: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeComparisonId(htmlId, value)),
			reverseSetImplementedChangeCompareType: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeCompareType(htmlId, value)),
			reverseSetImplementedChangeDescription: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeDescription(htmlId, value)),
			reverseSetImplementedChangeTime: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeTime(htmlId, value)),
			reverseSetImplementedChangeLength: (htmlId, value) => dispatch(actions.reverseSetImplementedChangeLength(htmlId, value)),

			setCommentTime: (time) => dispatch(actions.setCommentTime(time)),
			setCommentDate: (date) => dispatch(actions.setCommentDate(date)),
			setCommentDescription: (desc) => dispatch(actions.setCommentDescription(desc)),

			setPreSetTestDate: (date) => dispatch(actions.setPreSetTestDate(date)),
			setPreSetTestLength: (length) => dispatch(actions.setPreSetTestLength(length)),
			setPreSetTestIsDays: (isDays) => dispatch(actions.setPreSetTestIsDays(isDays)),
			setPreSetTestOccurs: (occurs) => dispatch(actions.setPreSetTestOccurs(occurs)),
			setPreSetTestDescription: (desc) => dispatch(actions.setPreSetTestDescription(desc)),
			setPreSetTestDescriptions: (index, desc) => dispatch(actions.setPreSetTestDescriptions(index, desc)),
			setPreSetTestDescriptionsDate: (index, date) => dispatch(actions.setPreSetTestDescriptionsDate(index, date)),
			setPreSetTestViewId: (htmlId, defaultValue) => dispatch(actions.setPreSetTestViewId(htmlId, defaultValue)),
			reverseSetPreSetTestViewId: (htmlId, value) => dispatch(actions.reverseSetPreSetTestViewId(htmlId, value)),

			deleteImplementedChange: (id) => dispatch(actions.deleteImplementedChange(id)),
			deletePreSetTest: (id) => dispatch(actions.deletePreSetTest(id)),
			deleteComment: (id) => dispatch(actions.deleteComment(id)),

			setSearchValue: (val) => dispatch(actions.setSearchValue(val)),
			search: () => dispatch(actions.search()),
			clearSearch: () => dispatch(actions.clearSearch()),
			clearModalData: () => dispatch(actions.clearModalData()),

      	navigate: (uri, data) => dispatch(router.push(uri, data)),
      	goBack: () => dispatch(router.goBack())
   	};
};

const mapStateToProps = state => ({
	flattenedSiteTree: state.sitetree.flattenedSiteTree,
	currentSite: state.sitetree.currentSite,
	currentTariff: state.tariffs.currentTariff,
	calendarOpen: state.evidenceChart.calendarOpen,
	time: state.evidenceService.time,
	showingDataType: state.evidenceChart.showingDataType,

	errors: state.evidenceChart.errors,
	rerender: state.evidenceChart.rerender,

	ic_time: state.evidenceChart.ic_time,
	ic_date: state.evidenceChart.ic_date,
	ic_description: state.evidenceChart.ic_description,
	ic_length: state.evidenceChart.ic_length,
	ic_isDays: state.evidenceChart.ic_isDays, 
	ic_comparisonId: state.evidenceChart.ic_comparisonId,
	ic_compareType: state.evidenceChart.ic_compareType,
	co_time: state.evidenceChart.co_time,
	co_date: state.evidenceChart.co_date,
	co_description: state.evidenceChart.co_description,
	pst_date: state.evidenceChart.pst_date,
	pst_isDays: state.evidenceChart.pst_isDays,
	pst_occurs: state.evidenceChart.pst_occurs,
	pst_descriptions: state.evidenceChart.pst_descriptions,
	pst_length: state.evidenceChart.pst_length,
	pst_description: state.evidenceChart.pst_description,
	viewId: state.evidenceChart.viewId,

	searchValue: state.evidenceChart.searchValue,
	searchText: state.evidenceChart.searchText,
	hasSearched: state.evidenceChart.hasSearched,
	searchResults: state.evidenceChart.searchResults,
	isSearchBusy: state.evidenceChart.isSearchBusy,
});

export default connect(
   mapStateToProps,
   bindAction
)(Chart);



// WEBPACK FOOTER //
// ./src/ui/Evidence/Evidence.js